import React, {useState} from 'react';
import glamorous from 'glamorous';
import SimpleButton from '../../../../shared/library/buttons/base/simple';
import {SigninDesktopModal} from '../../../../shared/library/modals/signin';
import {LAPTOP, PHONE} from '../../../../shared/style/breakpoints';

const Container = glamorous.div({
  [LAPTOP]: {
    width: '100%',
    margin: 'auto'
  },
  [PHONE]: {
    padding: '0 2px 15px 3px'
  }
});

const NavbarLogin = () => {
  const [isSignInModalOpen, setSignInModalOpen] = useState(false);
  return (
    <Container>
      <SimpleButton
        onClick={() => {
          setSignInModalOpen(true);
        }}
        style={{height: 38, padding: '10px 15px', width: '100%', whiteSpace: 'nowrap'}}
        data-testid="loginClick"
      >
        Sign up/Login
      </SimpleButton>
      {isSignInModalOpen && <SigninDesktopModal onDismiss={() => setSignInModalOpen(false)} />}
    </Container>
  );
};

export default NavbarLogin;
